import { WorkLoadFlags } from './work.types';

/**
 * Load-flag join logic for the work section: the view can only be set up once
 * the DOM fragment, the Pixi spritesheets and the section JSON have all
 * arrived. Note: this section does no fetching of its own — HTML/JSON are
 * pushed in by the app level via WorkController.setHTML (AJAX) / setJSON
 * (bundled config — AppController._setSectionConfigs).
 */
export class WorkLoading {
	private _loadFlags: WorkLoadFlags = { pixi: false, dom: false, json: false };
	private _readyToSetup: boolean = false; //Is ready to view. So can be setup for viewing oif required

	public get readyToSetup(): boolean {
		return this._readyToSetup;
	}

	public setFlag(flag: keyof WorkLoadFlags, value: boolean = true): void {
		this._loadFlags[flag] = value;
	}

	/** Test that the view is ready to setup */
	public testReadyToSetup(): void {
		this._readyToSetup = this._loadFlags.dom && this._loadFlags.pixi && this._loadFlags.json;
	}
}
